export default __webpack_public_path__ + "4b1650bec4150279ae2d05583eb13559.gif";